import { renderTopBar } from './shared/top-bar';
import { ICONS } from './shared/ui';

const app = document.getElementById('app')!;

const tools = [
  {
    href: '/model.html',
    icon: ICONS.cube(),
    title: 'Optimize a 3D model',
    body: 'Shrink a GLB for AR and fix what would stop it loading or looking right. Preview before and after, then download.',
    formats: 'GLB, glTF',
  },
  {
    href: '/video.html',
    icon: ICONS.film(),
    title: 'Optimize a video',
    body: 'Check whether a video will play smoothly in AR, then optimize it in your browser or copy an ffmpeg command.',
    formats: 'MP4, MOV, M4V, WebM',
  },
  {
    href: '/image.html',
    icon: ICONS.target(),
    title: 'Check an image marker',
    body: 'See whether a picture will track well as an AR marker, and what to change if it won’t.',
    formats: 'JPEG, PNG, WebP, AVIF',
  },
];

app.innerHTML = `
  ${renderTopBar('home')}
  <header class="landing-hero">
    <h1>Get your files ready for AR</h1>
    <p>Free tools that check your models, videos and marker images, then fix them — right in your browser.</p>
    <div class="privacy-note">${ICONS.lock()}Files stay on your device — nothing is uploaded.</div>
  </header>
  <nav class="tool-list" aria-label="Tools">
    ${tools.map(t => `
      <a class="tool-link" href="${t.href}">
        <span class="tool-icon">${t.icon}</span>
        <div>
          <h2>${t.title}</h2>
          <p>${t.body}</p>
          <div class="formats">${t.formats}</div>
        </div>
        <span class="tool-go">Open</span>
      </a>`).join('')}
  </nav>
`;
